import { Outlet } from 'react-router-dom';
import HeaderMenu from './header';
import Footer from './footer';

function DefaultLayout() {
    return (
        <div className='routerWrapper'>
            <HeaderMenu />
            <Outlet />
            <Footer />
        </div>
    );
}

export default DefaultLayout;
